
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/start-here/core-technology-discussions/miscellaneous",
      function () {
        return require("private-next-pages/docs/start-here/core-technology-discussions/miscellaneous/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/start-here/core-technology-discussions/miscellaneous"])
      });
    }
  